// Ääntämisvalmentaja's states and "what next" lines (the screens review of 2026-10-11, docs/design/coach-research/
// screens-review-2026-10-11.md): the lips camera's failures, a Peterson clip that did not load, what to do after a
// take (today's takes done, a passed step, an unsure take), the phone model missing or failing, an interrupted
// calibration, the microphone check's level label, the free mode's pitch scale and the hub's recognition row.
// Style: docs/FINNISH-STYLE.md (sinä, no jargon, no intro text). en: the same shape.
import { defineArea } from '../area';

export const coachStatesFi = {
  camera: {
    denied: 'Kameran käyttö on estetty. Salli se selaimen tai iPhonen asetuksista ja yritä uudelleen.',
    unsupported: 'Tämä selain ei pysty käyttämään kameraa.',
    missing: 'Huulikameran kasvomallia ei ole ladattu tälle laitteelle.',
    missingLink: 'Lataa se ääniasetuksista',
    error: 'Kamera ei auennut. Yritä uudelleen.',
  },
  live: {
    clipFailed: 'Petersonin äänite ei latautunut. Tarkista yhteys ja yritä uudelleen.',
    sayAgain: 'Sano uudelleen.',
    todayDone: 'Tämän päivän toistot on tehty. Jatka huomenna.',
    /** A link to the weakest sound: "Harjoittele seuraavaksi: jentys" */
    tryNext: (sound: string) => `Harjoittele seuraavaksi: ${sound}`,
    allDone: 'Kaikki askeleet ovat läpi.',
    modelMissing: 'Ääntämisen tunnistus ei ole tällä laitteella, joten arvio tulee vain mittareista.',
    modelFailed: 'Ääntämisen tunnistus ei käynnistynyt, joten arvio tulee vain mittareista.',
    modelLink: 'Ääniasetukset',
    openLadder: 'Avaa tikapuut.',
  },
  calibration: {
    interrupted: 'Kalibrointi keskeytyi. Aloita alusta.',
    invalid: 'Mittauksesta jäi puuttumaan ääniä. Tee kalibrointi uudelleen.',
    saveFailed: 'Tallennus ei onnistunut. Yritä uudelleen.',
    back: 'Takaisin valmentajaan',
  },
  diag: {
    level: 'taso',
    bandLow: 'sihinän paikkaa ei mitata',
  },
  voice: {
    /** The free mode's scale: semitones from your own middle. */
    scale: 'puolisävelaskelta omasta keskisävelestäsi',
  },
  hub: {
    model: 'Ääntämisen tunnistus',
    modelOn: 'Toimii tällä laitteella',
    modelFails: 'Ei toimi tällä laitteella',
    modelOff: 'Ei ladattu tälle laitteelle',
  },
};

export const coachStatesEn: typeof coachStatesFi = {
  camera: {
    denied: 'Camera access is blocked. Allow it in the browser or iPhone settings and try again.',
    unsupported: 'This browser cannot use the camera.',
    missing: "The lips camera's face model is not downloaded on this device.",
    missingLink: 'Download it in the audio settings',
    error: 'The camera did not open. Try again.',
  },
  live: {
    clipFailed: "Peterson's recording did not load. Check the connection and try again.",
    sayAgain: 'Say it again.',
    todayDone: "Today's takes are done. Carry on tomorrow.",
    tryNext: (sound) => `Practise next: ${sound}`,
    allDone: 'Every step has passed.',
    modelMissing: 'Pronunciation recognition is not on this device, so only the meters judge.',
    modelFailed: 'Pronunciation recognition did not start, so only the meters judge.',
    modelLink: 'Audio settings',
    openLadder: 'Open the ladder.',
  },
  calibration: {
    interrupted: 'The calibration was interrupted. Start again.',
    invalid: 'Some sounds are missing from the measurement. Calibrate again.',
    saveFailed: 'Saving did not work. Try again.',
    back: 'Back to the coach',
  },
  diag: {
    level: 'level',
    bandLow: "the hiss's place is not measured",
  },
  voice: {
    scale: 'semitones from your own middle pitch',
  },
  hub: {
    model: 'Pronunciation recognition',
    modelOn: 'Works on this device',
    modelFails: 'Does not work on this device',
    modelOff: 'Not downloaded on this device',
  },
};

// Messages.coachStates (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('coachStates', coachStatesFi, coachStatesEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof coachStatesFi> {}
}
